











































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import CreateIntegrationRequest from '@/models/Integrations/CreateIntegrationRequest';
import ListUtils from '@/lib/listUtils';

@Component({
    name: 'IntegrationCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new CreateIntegrationRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateIntegrationRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get availableIntegrations() {
    const currentIntegrations = AgencySettingsModule.integrations;
    // Get all possible integration systems
    const allSystems = ListUtils.integrationSystems();
    // Get the IDs of already installed integrations
    const installedIds = currentIntegrations.map((i: any) => i.integrationSystemId);
    // Return only systems not already installed
    return allSystems.filter((system: any) => !installedIds.includes(system.value));
  }


  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }

    await AgencySettingsModule.createIntegration(this.entity)
    this.dialog = false;
  }
}
